/**
 * Dental Care Savings Calculator - Embeddable Widget
 * Shopify Inline Calculator Widget
 * Version: 1.0.0
 * 
 * A premium step-based calculator that helps users
 * understand their dental care costs and potential savings.
 * Designed for inline embedding on any page.
 */

(function() {
  'use strict';

  // Prevent duplicate initialization
  if (window.DentalEmbedWidget) return;

  // ==========================================
  // CONFIGURATION
  // ==========================================
  
const CONFIG = {
  productPageUrl: 'https://midentcare.com/products/watersonic-by-mident',
  productHandle: 'watersonic-by-mident',
  discountCode: 'DENTAL15',
  title: 'Calculate Your Dental Savings',
  subtitle: 'Find out how much you could save on dental care over the next 5 years',
  showProductImage: true,
  showOriginalPrice: true,
  ctaText: 'View Product'
};

  // Read configuration from data attributes
  const mountEl = document.getElementById('dental-embed-widget');
  if (!mountEl) return;

CONFIG.productPageUrl = mountEl.dataset.productPageUrl || CONFIG.productPageUrl;
CONFIG.productHandle = mountEl.dataset.productHandle || CONFIG.productHandle;
CONFIG.discountCode = mountEl.dataset.discountCode || CONFIG.discountCode;
CONFIG.title = mountEl.dataset.title || CONFIG.title;
CONFIG.subtitle = mountEl.dataset.subtitle || CONFIG.subtitle;
CONFIG.showProductImage = mountEl.dataset.showProductImage !== 'false';
CONFIG.showOriginalPrice = mountEl.dataset.showOriginalPrice !== 'false';
CONFIG.ctaText = mountEl.dataset.ctaText || CONFIG.ctaText;

  // ==========================================
  // STATE MACHINE
  // ==========================================
  
  const SCREENS = {
    WELCOME: 'welcome',
    VISITS: 'visits',
    COST_PER_VISIT: 'cost_per_visit',
    HYGIENE_COST: 'hygiene_cost',
    TIME_COST: 'time_cost',
    PREVENTION: 'prevention',
    OPENNESS: 'openness',
    CALCULATING: 'calculating',
    RESULTS: 'results'
  };

  const SCREEN_ORDER = [
    SCREENS.WELCOME,
    SCREENS.VISITS,
    SCREENS.HYGIENE_COST,
    SCREENS.COST_PER_VISIT,
    SCREENS.TIME_COST,
    SCREENS.PREVENTION,
    SCREENS.OPENNESS,
    SCREENS.CALCULATING,
    SCREENS.RESULTS
  ];

  const state = {
    currentScreen: SCREENS.WELCOME,
    screenIndex: 0,
    totalSteps: 6,
    data: {
      visits_per_year: 2,
      cost_per_visit: 200,
      hygiene_cost: 150,
      hours_per_year: 3.5,
      prevention: 'no',
      openness: null,
      skipped: false
    },
    isTransitioning: false
  };

  let elements = {};

  // ==========================================
  // SVG ICONS
  // ==========================================
  
  const ICONS = {
    tooth: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2C9.5 2 7.5 3.5 7 5.5C6.5 7.5 6 9 5 11C4 13 3 15 4 17C5 19 6 21 8 21C10 21 10.5 19 12 19C13.5 19 14 21 16 21C18 21 19 19 20 17C21 15 20 13 19 11C18 9 17.5 7.5 17 5.5C16.5 3.5 14.5 2 12 2Z"/></svg>`,
    
    arrowRight: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>`,
    
    arrowLeft: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>`,
    
    refresh: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>`,
    
    check: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`,
    
    calculator: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="8" y1="10" x2="8" y2="10.01"/><line x1="12" y1="10" x2="12" y2="10.01"/><line x1="16" y1="10" x2="16" y2="10.01"/><line x1="8" y1="14" x2="8" y2="14.01"/><line x1="12" y1="14" x2="12" y2="14.01"/><line x1="16" y1="14" x2="16" y2="14.01"/><line x1="8" y1="18" x2="8" y2="18.01"/><line x1="12" y1="18" x2="16" y2="18"/></svg>`,
    
    clock: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>`,
    
    dollar: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>`,
    
    heart: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>`,
    
    sparkles: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.912 5.813a2 2 0 001.275 1.275L21 12l-5.813 1.912a2 2 0 00-1.275 1.275L12 21l-1.912-5.813a2 2 0 00-1.275-1.275L3 12l5.813-1.912a2 2 0 001.275-1.275L12 3z"/></svg>`,
    
    cart: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>`,
    
    external: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>`
  };

  // ==========================================
  // UTILITY FUNCTIONS
  // ==========================================
  
  function formatUSD(amount) {
    return '$' + Math.round(amount).toLocaleString('en-US');
  }

  function roundToNearest100(amount) {
    return Math.round(amount / 100) * 100;
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function dispatchAnalytics(eventName, data = {}) {
    window.dispatchEvent(new CustomEvent(eventName, { 
      detail: { ...data, timestamp: Date.now() }
    }));
  }

  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // ==========================================
  // CALCULATION LOGIC
  // ==========================================
  
  // Product price - fetched dynamically from Shopify, with fallback
 let productPrice = 169; // fallback
let productData = null;

async function fetchProductData() {
  try {
    const response = await fetch(`/products/${CONFIG.productHandle}.js`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const product = await response.json();
    const variant = product.variants.find(v => v.available) || product.variants[0] || null;

    const currentPrice = variant && typeof variant.price === 'number'
      ? variant.price / 100
      : productPrice;

    const compareAtPrice = variant && typeof variant.compare_at_price === 'number'
      ? variant.compare_at_price / 100
      : 0;

    productPrice = currentPrice;

    productData = {
      id: product.id || null,
      name: product.title || 'WaterSonic',
      url: product.url ? product.url : `/products/${product.handle}`,
      image: product.featured_image || '',
      price: currentPrice,
      regular_price: compareAtPrice,
      sale_price: compareAtPrice > currentPrice ? currentPrice : 0,
      is_in_stock: !!(variant && variant.available),
      stock_quantity: typeof variant?.inventory_quantity === 'number' ? variant.inventory_quantity : null,
      description: product.description || '',
      handle: product.handle || CONFIG.productHandle
    };
  } catch (error) {
    console.warn('Dental Embed: Could not fetch product data, using fallback', error);

    productData = {
      id: null,
      name: 'WaterSonic',
      url: CONFIG.productPageUrl,
      image: '',
      price: productPrice,
      regular_price: 0,
      sale_price: 0,
      is_in_stock: true,
      stock_quantity: null,
      description: '',
      handle: CONFIG.productHandle
    };
  }

  return productData;
}
  
  function calculateResults() {
    const v = state.data.visits_per_year;
    const c = state.data.cost_per_visit;
    const h = state.data.hygiene_cost;
    const t = state.data.hours_per_year;
    const prevention = state.data.prevention;

    // Baseline 5-year cost (without our product)
    const baseline5y = 5 * v * (c + h);
    
    // Time cost (hours over 5 years)
    const time5yHours = Math.round(5 * t);
    
    // Savings calculation: 
    // With our product, you can significantly reduce dental visits and costs.
    // The savings = baseline costs - product price (what you actually save by switching)
    // We apply a reduction factor based on prevention habits to be realistic:
    // - Already using advanced tools: 70% of baseline can be saved
    // - Sometimes: 80% of baseline can be saved  
    // - No prevention: 90% of baseline can be saved (biggest improvement potential)
    let reductionRate;
    switch (prevention) {
      case 'yes':
        reductionRate = 0.70; // Already doing well, still save 70%
        break;
      case 'sometimes':
        reductionRate = 0.80; // Room for improvement, save 80%
        break;
      default:
        reductionRate = 0.90; // Biggest potential, save 90%
    }
    
    // Calculate potential savings: most of baseline costs minus the product investment
    const grossSavings = baseline5y * reductionRate;
    const savings5y = roundToNearest100(Math.max(grossSavings - productPrice, 0));
    
    return {
      baseline5y,
      time5yHours,
      savings5y,
      reductionRate
    };
  }

  // ==========================================
  // NAVIGATION
  // ==========================================
  
  function getStepNumber() {
    // Map screen to user-facing step number (1-6)
    const stepMap = {
      [SCREENS.VISITS]: 1,
      [SCREENS.HYGIENE_COST]: 2,
      [SCREENS.COST_PER_VISIT]: 3,
      [SCREENS.TIME_COST]: 4,
      [SCREENS.PREVENTION]: 5,
      [SCREENS.OPENNESS]: 6
    };
    return stepMap[state.currentScreen] || 0;
  }

  function canGoBack() {
    return state.screenIndex > 0 && state.currentScreen !== SCREENS.WELCOME && state.currentScreen !== SCREENS.RESULTS;
  }

  function goBack() {
    if (!canGoBack() || state.isTransitioning) return;
    
    const currentIndex = SCREEN_ORDER.indexOf(state.currentScreen);
    if (currentIndex > 0) {
      navigateToScreen(SCREEN_ORDER[currentIndex - 1], 'back');
    }
  }

  async function navigateToScreen(screen, direction = 'forward') {
    if (state.isTransitioning) return;
    state.isTransitioning = true;
    
    // Update state
    state.currentScreen = screen;
    state.screenIndex = SCREEN_ORDER.indexOf(screen);
    updateProgress();
    
    // Instant swap - no animation
    elements.screenContainer.innerHTML = '';
    renderScreen(screen, direction);
    
    state.isTransitioning = false;
  }

  function updateProgress() {
    const step = getStepNumber();
    const percent = (step / state.totalSteps) * 100;
    
    elements.progressFill.style.width = `${percent}%`;
    elements.progressText.textContent = step > 0 ? `Step ${step} of ${state.totalSteps}` : 'Get Started';
    
    // Show/hide back button - never show on welcome or results screen
    const showBack = state.currentScreen !== SCREENS.WELCOME && 
                     state.currentScreen !== SCREENS.RESULTS && 
                     state.currentScreen !== SCREENS.CALCULATING &&
                     state.screenIndex > 1;
    
    if (showBack) {
      elements.backBtn.classList.add('is-visible');
    } else {
      elements.backBtn.classList.remove('is-visible');
    }
  }

  // ==========================================
  // SCREEN RENDERING
  // ==========================================
  
  function renderScreen(screen, direction = 'forward') {
    let html = '';
    
    switch (screen) {
      case SCREENS.WELCOME:
        html = renderWelcomeScreen();
        break;
      case SCREENS.VISITS:
        html = renderVisitsScreen();
        break;
      case SCREENS.COST_PER_VISIT:
        html = renderCostPerVisitScreen();
        break;
      case SCREENS.HYGIENE_COST:
        html = renderHygieneCostScreen();
        break;
      case SCREENS.TIME_COST:
        html = renderTimeCostScreen();
        break;
      case SCREENS.PREVENTION:
        html = renderPreventionScreen();
        break;
      case SCREENS.OPENNESS:
        html = renderOpennessScreen();
        break;
      case SCREENS.CALCULATING:
        html = renderCalculatingScreen();
        break;
      case SCREENS.RESULTS:
        html = renderResultsScreen();
        break;
    }
    
    const screenEl = document.createElement('div');
    screenEl.className = `de-screen de-screen--${screen}`;
    screenEl.innerHTML = html;
    
    elements.screenContainer.appendChild(screenEl);
    
    // Bind screen-specific events
    bindScreenEvents(screen, screenEl);
    
    // Auto-advance for calculating screen - fetch product price while "calculating"
if (screen === SCREENS.CALCULATING) {
  fetchProductData().then(() => {
    setTimeout(() => navigateToScreen(SCREENS.RESULTS), 1000);
  });
}
  }

  function bindScreenEvents(screen, screenEl) {
    // Option buttons
    const optionBtns = screenEl.querySelectorAll('.de-option-btn');
    optionBtns.forEach(btn => {
      btn.addEventListener('click', () => handleOptionSelect(btn));
    });
    
    // Input fields
    const inputField = screenEl.querySelector('.de-input-field');
    const submitBtn = screenEl.querySelector('.de-submit-btn');
    
    if (inputField && submitBtn) {
      submitBtn.addEventListener('click', () => handleInputSubmit(inputField, screen));
      inputField.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleInputSubmit(inputField, screen);
        }
      });
      // Auto-focus input
      setTimeout(() => inputField.focus(), 300);
    }
    
    // CTA button
    const primaryCta = screenEl.querySelector('.de-cta-primary');
    
    if (primaryCta) {
      primaryCta.addEventListener('click', handlePrimaryCTA);
    }
    
    // Start button
    const startBtn = screenEl.querySelector('.de-start-btn');
    if (startBtn) {
      startBtn.addEventListener('click', () => {
        dispatchAnalytics('dental_embed_start');
        navigateToScreen(SCREENS.VISITS);
      });
    }
    
    // Quick start button
    const quickBtn = screenEl.querySelector('.de-quick-btn');
    if (quickBtn) {
      quickBtn.addEventListener('click', () => {
        state.data.skipped = true;
        dispatchAnalytics('dental_embed_quick');
        navigateToScreen(SCREENS.CALCULATING);
      });
    }
    
    // Restart button
    const restartBtn = screenEl.querySelector('.de-restart-btn');
    if (restartBtn) {
      restartBtn.addEventListener('click', reset);
    }


const viewProductBtn = screenEl.querySelector('.de-view-product');
if (viewProductBtn) {
  viewProductBtn.addEventListener('click', () => {
    dispatchAnalytics('dental_embed_cta_primary', {
      productHandle: CONFIG.productHandle,
      discountCode: CONFIG.discountCode
    });

    window.location.href = CONFIG.productPageUrl;
  });
}

  }

  function handleOptionSelect(btn) {
    const value = btn.dataset.value;
    const key = btn.dataset.key;
    const nextScreen = btn.dataset.next;
    
    // Prevent double-clicks
    if (btn.disabled) return;
    
    // Disable all options instantly
    const allOptions = btn.closest('.de-options').querySelectorAll('.de-option-btn');
    allOptions.forEach(b => {
      b.disabled = true;
      b.style.pointerEvents = 'none';
    });
    btn.classList.add('is-selected');
    
    // Save data
    if (key) {
      const parsedValue = isNaN(parseFloat(value)) ? value : parseFloat(value);
      state.data[key] = parsedValue;
    }
    
    // Navigate immediately - tiny delay for visual feedback
    setTimeout(() => {
      navigateToScreen(nextScreen);
    }, 100);
  }

  function handleInputSubmit(inputField, screen) {
    const value = inputField.value.trim();
    const num = parseFloat(value.replace(/[^0-9.]/g, ''));
    
    if (isNaN(num) || num <= 0) {
      inputField.classList.add('de-input--error');
      setTimeout(() => inputField.classList.remove('de-input--error'), 500);
      return;
    }
    
    // Save and navigate
    if (screen === SCREENS.HYGIENE_COST) {
      state.data.hygiene_cost = num;
      navigateToScreen(SCREENS.COST_PER_VISIT);
    } else if (screen === SCREENS.COST_PER_VISIT) {
      state.data.cost_per_visit = num;
      navigateToScreen(SCREENS.TIME_COST);
    }
  }

  // ==========================================
  // SCREEN TEMPLATES
  // ==========================================
  
  function renderWelcomeScreen() {
    return `
      <div class="de-welcome">
        <div class="de-welcome__icon">
          <div class="de-welcome__icon-bg"></div>
          ${ICONS.calculator}
        </div>
        <h2 class="de-welcome__title">${escapeHtml(CONFIG.title)}</h2>
        <p class="de-welcome__subtitle">${escapeHtml(CONFIG.subtitle)}</p>
        <div class="de-welcome__features">
          <div class="de-feature">
            <span class="de-feature__icon">${ICONS.clock}</span>
            <span class="de-feature__text">Takes 60 seconds</span>
          </div>
          <div class="de-feature">
            <span class="de-feature__icon">${ICONS.dollar}</span>
            <span class="de-feature__text">Personalized savings</span>
          </div>
          <div class="de-feature">
            <span class="de-feature__icon">${ICONS.heart}</span>
            <span class="de-feature__text">Expert recommendations</span>
          </div>
        </div>
        <div class="de-welcome__actions">
          <button class="de-btn de-btn--primary de-start-btn">
            <span>Start Calculating</span>
            <span class="de-btn__icon">${ICONS.arrowRight}</span>
          </button>
          <button class="de-btn de-btn--ghost de-quick-btn">
            Use average values instead
          </button>
        </div>
      </div>
    `;
  }

  function renderVisitsScreen() {
    return `
      <div class="de-question">
        <div class="de-question__header">
          <div class="de-question__number">1</div>
          <div class="de-question__content">
            <h3 class="de-question__title">How often do you visit the dentist each year?</h3>
            <p class="de-question__hint">Include checkups, hygiene visits, and treatments</p>
          </div>
        </div>
        <div class="de-options">
          <button class="de-option-btn" data-value="1" data-key="visits_per_year" data-next="${SCREENS.HYGIENE_COST}">
            <span class="de-option__label">Once a year</span>
            <span class="de-option__meta">Basic maintenance</span>
          </button>
          <button class="de-option-btn" data-value="2" data-key="visits_per_year" data-next="${SCREENS.HYGIENE_COST}">
            <span class="de-option__label">Twice a year</span>
            <span class="de-option__meta">Recommended frequency</span>
          </button>
          <button class="de-option-btn" data-value="3" data-key="visits_per_year" data-next="${SCREENS.HYGIENE_COST}">
            <span class="de-option__label">Three times a year</span>
            <span class="de-option__meta">Active care</span>
          </button>
          <button class="de-option-btn" data-value="4" data-key="visits_per_year" data-next="${SCREENS.HYGIENE_COST}">
            <span class="de-option__label">More than three times</span>
            <span class="de-option__meta">Intensive treatment</span>
          </button>
        </div>
      </div>
    `;
  }

  function renderCostPerVisitScreen() {
    return `
      <div class="de-question">
        <div class="de-question__header">
          <div class="de-question__number">3</div>
          <div class="de-question__content">
            <h3 class="de-question__title">How much does one dental visit cost you?</h3>
            <p class="de-question__hint">Include checkups or minor treatments — on average</p>
          </div>
        </div>
        <div class="de-input-group">
          <div class="de-input-wrapper">
            <span class="de-input-prefix">$</span>
            <input type="text" class="de-input-field" placeholder="200" inputmode="numeric" autocomplete="off">
          </div>
          <button class="de-btn de-btn--primary de-submit-btn">
            <span>Continue</span>
            <span class="de-btn__icon">${ICONS.arrowRight}</span>
          </button>
          <div class="de-input-hint">
            <span class="de-input-hint__label">Average:</span> $150 - $300 per visit
          </div>
        </div>
      </div>
    `;
  }

  function renderHygieneCostScreen() {
    return `
      <div class="de-question">
        <div class="de-question__header">
          <div class="de-question__number">2</div>
          <div class="de-question__content">
            <h3 class="de-question__title">How much do you pay for dental hygiene or cleaning?</h3>
            <p class="de-question__hint">Cost per cleaning session</p>
          </div>
        </div>
        <div class="de-input-group">
          <div class="de-input-wrapper">
            <span class="de-input-prefix">$</span>
            <input type="text" class="de-input-field" placeholder="150" inputmode="numeric" autocomplete="off">
          </div>
          <button class="de-btn de-btn--primary de-submit-btn">
            <span>Continue</span>
            <span class="de-btn__icon">${ICONS.arrowRight}</span>
          </button>
          <div class="de-input-hint">
            <span class="de-input-hint__label">Average:</span> $100 - $200 per session
          </div>
        </div>
      </div>
    `;
  }

  function renderTimeCostScreen() {
    return `
      <div class="de-question">
        <div class="de-question__header">
          <div class="de-question__number">4</div>
          <div class="de-question__content">
            <h3 class="de-question__title">How much time does dental care take from you each year?</h3>
            <p class="de-question__hint">Including travel, waiting, and treatment time</p>
          </div>
        </div>
        <div class="de-options">
          <button class="de-option-btn" data-value="1.5" data-key="hours_per_year" data-next="${SCREENS.PREVENTION}">
            <span class="de-option__label">Less than 2 hours</span>
            <span class="de-option__meta">Quick in-and-out visits</span>
          </button>
          <button class="de-option-btn" data-value="3.5" data-key="hours_per_year" data-next="${SCREENS.PREVENTION}">
            <span class="de-option__label">2–5 hours</span>
            <span class="de-option__meta">Average time commitment</span>
          </button>
          <button class="de-option-btn" data-value="8" data-key="hours_per_year" data-next="${SCREENS.PREVENTION}">
            <span class="de-option__label">6–10 hours</span>
            <span class="de-option__meta">Multiple appointments</span>
          </button>
          <button class="de-option-btn" data-value="12" data-key="hours_per_year" data-next="${SCREENS.PREVENTION}">
            <span class="de-option__label">More than 10 hours</span>
            <span class="de-option__meta">Extended treatment plans</span>
          </button>
        </div>
      </div>
    `;
  }

  function renderPreventionScreen() {
    return `
      <div class="de-question">
        <div class="de-question__header">
          <div class="de-question__number">5</div>
          <div class="de-question__content">
            <h3 class="de-question__title">Do you use any advanced dental care at home?</h3>
            <p class="de-question__hint">Beyond a regular manual toothbrush</p>
          </div>
        </div>
        <div class="de-options de-options--compact">
          <button class="de-option-btn" data-value="yes" data-key="prevention" data-next="${SCREENS.OPENNESS}">
            <span class="de-option__label">Yes, regularly</span>
            <span class="de-option__meta">Electric toothbrush, water flosser, etc.</span>
          </button>
          <button class="de-option-btn" data-value="sometimes" data-key="prevention" data-next="${SCREENS.OPENNESS}">
            <span class="de-option__label">Occasionally</span>
            <span class="de-option__meta">Sometimes use advanced tools</span>
          </button>
          <button class="de-option-btn" data-value="no" data-key="prevention" data-next="${SCREENS.OPENNESS}">
            <span class="de-option__label">No, just a toothbrush</span>
            <span class="de-option__meta">Standard brushing only</span>
          </button>
        </div>
      </div>
    `;
  }

  function renderOpennessScreen() {
    return `
      <div class="de-question">
        <div class="de-question__header">
          <div class="de-question__number">6</div>
          <div class="de-question__content">
            <h3 class="de-question__title">Would you like a solution that could reduce dental visits?</h3>
            <p class="de-question__hint">By improving daily plaque removal at home</p>
          </div>
        </div>
        <div class="de-options de-options--compact">
          <button class="de-option-btn" data-value="yes" data-key="openness" data-next="${SCREENS.CALCULATING}">
            <span class="de-option__label">Yes, definitely</span>
          </button>
          <button class="de-option-btn" data-value="learn" data-key="openness" data-next="${SCREENS.CALCULATING}">
            <span class="de-option__label">I'd like to learn more</span>
          </button>
          <button class="de-option-btn" data-value="unsure" data-key="openness" data-next="${SCREENS.CALCULATING}">
            <span class="de-option__label">I'm not sure yet</span>
          </button>
        </div>
      </div>
    `;
  }

  function renderCalculatingScreen() {
    return `
      <div class="de-calculating">
        <div class="de-calculating__animation">
          <div class="de-calculating__ring"></div>
          <div class="de-calculating__ring"></div>
          <div class="de-calculating__icon">${ICONS.sparkles}</div>
        </div>
        <h3 class="de-calculating__title">Calculating your results...</h3>
        <p class="de-calculating__subtitle">Analyzing your dental care profile</p>
      </div>
    `;
  }

 function renderResultsScreen() {
  const results = calculateResults();

  dispatchAnalytics('dental_embed_complete', {
    baseline5y: results.baseline5y,
    savings5y: results.savings5y,
    skipped: state.data.skipped,
    page: window.location.pathname,
    productHandle: CONFIG.productHandle
  });

  const productName = productData?.name || 'WaterSonic';
  const hasProduct = !!(productData && productData.url);

  const currentPrice = productData?.price || 0;
  const regularPrice = productData?.regular_price || 0;
  const salePrice = productData?.sale_price || 0;

  let stockHtml = '';
  if (productData) {
    if (productData.is_in_stock) {
      if (productData.stock_quantity && productData.stock_quantity <= 5) {
        stockHtml = `<span class="de-badge de-badge--low-stock">⚡ Only ${productData.stock_quantity} left</span>`;
      } else {
        stockHtml = `<span class="de-badge de-badge--in-stock">✓ In stock</span>`;
      }
    } else {
      stockHtml = `<span class="de-badge de-badge--out-stock">Out of stock</span>`;
    }
  }

  let priceHtml = '';
  const discountedPrice = salePrice || currentPrice;
  const hasDiscount = CONFIG.showOriginalPrice && regularPrice > 0 && discountedPrice > 0 && regularPrice > discountedPrice;

  if (hasDiscount) {
    priceHtml = `
      <div class="de-product__price">
        <span class="de-price-before-sale">${formatUSD(regularPrice)}</span>
        <span class="de-price-current">${formatUSD(discountedPrice)}</span>
      </div>
    `;
  } else if (currentPrice > 0) {
    priceHtml = `
      <div class="de-product__price">
        <span class="de-price-current">${formatUSD(currentPrice)}</span>
      </div>
    `;
  }

  const priceNoteHtml = currentPrice > 0
    ? `<div class="de-product__price-note">One-time investment for better daily dental care</div>`
    : '';

  let imageHtml = '';
  if (hasProduct && productData?.image && CONFIG.showProductImage) {
    imageHtml = `
      <div class="de-product__image-wrapper">
        <img src="${productData.image}" alt="${escapeHtml(productName)}" class="de-product__image">
      </div>
    `;
  }

  let savingsHtml = '';
  if (results.savings5y > 0) {
    savingsHtml = `
      <div class="de-savings">
        <div class="de-savings__header">
          <span class="de-savings__icon">${ICONS.sparkles}</span>
          <span class="de-savings__title">Potential Savings</span>
        </div>
        <div class="de-savings__amount">${formatUSD(results.savings5y)}</div>
        <div class="de-savings__subtitle">with better home dental care</div>

        <div class="de-savings__benefits">
          <div class="de-benefit">
            <span class="de-benefit__icon">${ICONS.check}</span>
            <span>Reduce plaque buildup between visits</span>
          </div>
          <div class="de-benefit">
            <span class="de-benefit__icon">${ICONS.check}</span>
            <span>Fewer hygiene appointments needed</span>
          </div>
          <div class="de-benefit">
            <span class="de-benefit__icon">${ICONS.check}</span>
            <span>Healthier gums and fresher breath</span>
          </div>
        </div>
      </div>
    `;
  } else {
    savingsHtml = `
      <div class="de-savings">
        <div class="de-savings__header">
          <span class="de-savings__icon">${ICONS.sparkles}</span>
          <span class="de-savings__title">Benefits</span>
        </div>

        <div class="de-savings__benefits">
          <div class="de-benefit">
            <span class="de-benefit__icon">${ICONS.check}</span>
            <span>Reduce plaque buildup between visits</span>
          </div>
          <div class="de-benefit">
            <span class="de-benefit__icon">${ICONS.check}</span>
            <span>Fewer hygiene appointments needed</span>
          </div>
          <div class="de-benefit">
            <span class="de-benefit__icon">${ICONS.check}</span>
            <span>Healthier gums and fresher breath</span>
          </div>
        </div>
      </div>
    `;
  }

  return `
    <div class="de-results">
      <div class="de-results__header">
        <div class="de-results__badge">Your 5-Year Analysis</div>
        <h2 class="de-results__title">Here's what we found</h2>
      </div>
      
      <div class="de-results__cards">
        <div class="de-stat-card de-stat-card--cost">
          <div class="de-stat-card__icon">${ICONS.dollar}</div>
          <div class="de-stat-card__content">
            <div class="de-stat-card__value">${formatUSD(results.baseline5y)}</div>
            <div class="de-stat-card__label">Projected dental costs</div>
          </div>
        </div>
        
        <div class="de-stat-card de-stat-card--time">
          <div class="de-stat-card__icon">${ICONS.clock}</div>
          <div class="de-stat-card__content">
            <div class="de-stat-card__value">${results.time5yHours} hours</div>
            <div class="de-stat-card__label">Time at dental offices</div>
          </div>
        </div>
      </div>
      
      ${savingsHtml}
      
      <div class="de-product">
        <div class="de-product__header">
          <div class="de-product__eyebrow">Based on your answers</div>
          <h3 class="de-product__title">${escapeHtml(productName)}</h3>
          <div class="de-product__badges">
            <span class="de-badge de-badge--discount">15% OFF</span>
            ${stockHtml}
          </div>
        </div>

        ${imageHtml}
        ${priceHtml}
        ${priceNoteHtml}

        <p class="de-product__desc">
          The <strong>${escapeHtml(productName)}</strong> helps maintain cleaner teeth between dental visits and supports better daily plaque removal at home.
        </p>

        <div class="de-product__actions">
          ${hasProduct ? `
            <button class="de-btn de-btn--primary de-btn--lg de-view-product">
              <span>${escapeHtml(CONFIG.ctaText)}</span>
              <span class="de-btn__icon">${ICONS.arrowRight}</span>
            </button>
          ` : ''}
        </div>
      </div>
      
      <button class="de-restart-btn">
        <span class="de-restart-btn__icon">${ICONS.refresh}</span>
        <span>Start Over</span>
      </button>
    </div>
  `;
}

  // ==========================================
  // CTA HANDLERS
  // ==========================================
  
  let ctaProcessing = false;

  function handlePrimaryCTA(event) {
    if (ctaProcessing) return;
    ctaProcessing = true;
    
    dispatchAnalytics('dental_embed_cta_primary', {
      productHandle: CONFIG.productHandle,
      discountCode: CONFIG.discountCode
    });
    
    // Redirect to product page
    window.location.href = CONFIG.productPageUrl;
  }


  // ==========================================
  // RESET
  // ==========================================
  
  function reset() {
    state.currentScreen = SCREENS.WELCOME;
    state.screenIndex = 0;
    state.data = {
      visits_per_year: 2,
      cost_per_visit: 200,
      hygiene_cost: 150,
      hours_per_year: 3.5,
      prevention: 'no',
      openness: null,
      skipped: false
    };
    ctaProcessing = false;
    
    elements.screenContainer.innerHTML = '';
    renderScreen(SCREENS.WELCOME);
    updateProgress();
    
    dispatchAnalytics('dental_embed_reset');
  }

  // ==========================================
  // RENDER MAIN WIDGET
  // ==========================================
  
  function render() {
    mountEl.innerHTML = `
      <div class="de-container">
        <div class="de-header">
          <button class="de-back-btn">
            ${ICONS.arrowLeft}
            <span>Back</span>
          </button>
          <div class="de-progress">
            <span class="de-progress__text">Get Started</span>
            <div class="de-progress__bar">
              <div class="de-progress__fill"></div>
            </div>
          </div>
          <div class="de-header__brand">
            <span class="de-header__icon">${ICONS.tooth}</span>
          </div>
        </div>
        <div class="de-body">
          <div class="de-screen-container"></div>
        </div>
      </div>
    `;
    
    // Cache elements
    elements = {
      container: mountEl.querySelector('.de-container'),
      header: mountEl.querySelector('.de-header'),
      backBtn: mountEl.querySelector('.de-back-btn'),
      progressText: mountEl.querySelector('.de-progress__text'),
      progressFill: mountEl.querySelector('.de-progress__fill'),
      body: mountEl.querySelector('.de-body'),
      screenContainer: mountEl.querySelector('.de-screen-container')
    };
  }

  // ==========================================
  // EVENT BINDING
  // ==========================================
  
  function bindEvents() {
    elements.backBtn.addEventListener('click', goBack);
  }

  // ==========================================
  // INITIALIZATION
  // ==========================================
  
  function init() {
    render();
    bindEvents();
    renderScreen(SCREENS.WELCOME);
    updateProgress();
    
    // Expose API
    window.DentalEmbedWidget = {
      reset,
      getState: () => ({ ...state }),
      getResults: () => calculateResults()
    };
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

